export default __webpack_public_path__ + "static/media/DiSC_Icon.70a9839c.png";